export default {
    Contract,
    ContractDraft,
    User,
    Hint,
    Community,
    BillingAddress,
    Features,
    LandscapeQuestions,
    ProviderInfo,
    DataAccessReferences,
    DataAccessVariables,
    CampaignLanding,
    RefGoals,
    Contact,
    LogNavigation,
    NavError,
    TariffResource,
    SelfReport,
    BillingAcc,
    Invoice,
    AnonPayment,
    AnonTermination,
    SecurityDeposit,
    Tokens,
}

/** @ngInject */
function Contract($resource) {
    return $resource(
        '/api/my-contract/:id', { id: '@id' }, {
            report: {
                url: '/api-user/my-contract/:id/self-report',
                method: 'POST',
            },
            burnToBill: {
                url: '/api/my-contract/:id/burn-pot-to-bill',
                method: 'POST',
            },
            burnToInvestment: {
                url: '/api/investment',
                method: 'POST',
            },
            getInvoices: {
                url: '/api/my-contract/:id/invoices',
                method: 'GET',
            },
            myCons: {
                url: '/api/my-cons/:id',
                method: 'GET',
                isArray: true,
            },
            myConsV2: {
                url: '/api-user/my-cons/:id',
                method: 'GET',
                isArray: true,
            },
            bypassRetraction: {
                url: '/api-user/selfcare/contract/:id/bypass_retraction',
                method: 'POST',
            },
            retract: {
                url: '/api-user/selfcare/contract/:id/retract',
                method: 'POST',
            },
            refGoal: {
                url: '/api-user/selfcare/contract/:id/goal',
                method: 'PUT',
            },
            isDepositNeeded: {
                url: '/api/contracts/:id/deposit-needed',
                method: 'GET',
            },
            isDepositNeededByToken: {
                url: '/anon/contracts/deposit-needed',
                method: 'GET',
            },
            getRedirectToSecurityDeposit: {
                url: '/api-user/my-contract/:id/security-deposit-redirect',
                method: 'GET',
            },
            cancelContract: {
                url: '/api-user/my-contract/:id/cancel',
                method: 'PUT',
            },
            regularize: {
                url: '/api-user/my-contract/:id/regularize',
                method: 'GET',
            },
        }
    )
}

/** @ngInject */
function ContractDraft($resource) {
    return $resource(
        '/api/my-contract-draft', {}, {
            get: {
                method: 'GET',
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                },
            },
            getByToken: {
                url: '/anon/my-contract-draft',
                method: 'GET',
            },
            update: {
                method: 'PUT',
            },
            updateByToken: {
                url: '/anon/my-contract-draft',
                method: 'PUT',
            },
            verify: {
                url: '/api-user/eligibility/prm/:id',
                method: 'GET',
            },
            checkPostCode: {
                url: '/api-user/eligibility/postcode/:id',
                method: 'GET',
            },
            getPaymentIframe: {
                url: '/api-user/generate-mandate/:id',
                method: 'GET',
            },
            getPaymentIframeByToken: {
                url: '/anon/generate-mandate/:id',
                method: 'GET',
            },
            checkSponsor: {
                url: '/api/my-contract-draft/sponsor/:sponsor_id',
            },
            checkPromo: {
                url: '/api-user/my-promo/:promo/check',
            },
            checkPromoOnDraft: {
                url: '/api-user/my-contract-draft/:id_draft/check-promo/:promo',
            },
            checkLandscapeRequired: {
                url: '/api-user/landscape/:id_contract/required?draft=true',
            },
            getTimetableV1: {
                url: '/api-user/my-contract-draft/timetable',
                method: 'POST',
                isArray: true,
            },
            getTimetableV2: {
                url: '/api-user/my-contract-draft/timetable/simu',
                method: 'POST',
                isArray: true,
            },
            getTimetableByToken: {
                url: '/anon/my-contract-draft/timetable',
                method: 'POST',
                isArray: true,
            },
            getQuotation: {
                url: '/api-user/my-contract-draft/quotation',
                method: 'POST',
            },
            report: {
                url: '/api/my-contract-draft/self-report',
                method: 'POST',
                isArray: true,
            },
            modifyDraftOffer: {
                url: '/api/my-contract-draft/offer/:provider_offer',
                method: 'PUT',
            },
            createJiraIssue: {
                method: 'POST',
                url: '/api-user/jira/issue/:idProject',
            },
            getOfferSelectable: {
                url: '/api/ref-provider-offers/:provider_offer/selectable',
                method: 'GET',
            },
            computeEnedisPrestations: {
                url: '/api-user/enedis-prestations/computation?draft=true',
                method: 'POST',
            },
        }
    )
}

/** @ngInject */
function User($resource) {
    return $resource(
        'anon', {}, {
            signUp: {
                url: '/anon/signup',
                method: 'POST',
            },
            setPassword: {
                url: '/anon/passwd/:token',
                method: 'POST',
            },
            getInfoByToken: {
                url: '/anon/process/:token',
                method: 'GET',
            },
            resetPassword: {
                url: '/anon/forgot-passwd',
                method: 'POST',
            },
            authenticate: {
                url: '/authenticate',
                method: 'POST',
            },
            logout: {
                url: '/api-user/logout',
                method: 'POST',
            },
            getInfo: {
                url: '/api/my-info',
                method: 'GET',
            },
            getPotBalance: {
                url: '/api/pot-balance',
                method: 'GET',
            },
            getBillingAddress: {
                url: '/api/my-billing-acc',
                method: 'GET',
            },
            getMyIban: {
                url: '/api-user/my-iban',
                method: 'GET',
            },
            getUa: {
                url: '/api/my-ua/',
                method: 'GET',
                isArray: true,
            },
            getProofOfResidence: {
                url: '/api-user/documents/:id_contract/proofofresidence',
                method: 'POST',
                responseType: 'arraybuffer',
            },
            getContractCertificate: {
                url: '/api-user/documents/:id_contract/contractcertificate',
                method: 'GET',
                responseType: 'arraybuffer',
            },
            saveNewBillingAddress: {
                url: '/api-user/selfcare/addr-modif',
                method: 'POST',
            },
            saveNewPhoneNumber: {
                url: '/api-user/selfcare/phone-modif',
                method: 'POST',
            },
            confirmNewPhoneNumber: {
                url: '/api-user/selfcare/phone-modif/:id_confirmation',
                method: 'POST',
            },
            saveNewEmail: {
                url: '/api-user/selfcare/email-modif',
                method: 'POST',
            },
            confirmNewEmail: {
                url: '/api-user/selfcare/email-modif/:processId',
                method: 'POST',
            },
            saveNominativeInfo: {
                url: '/api-user/selfcare/my-info',
                method: 'PUT',
            },
            saveIban: {
                url: '/api-user/my-mandate',
                method: 'PUT',
            },
            signMandate: {
                url: '/api-user/my-account/sign-mandate',
                method: 'GET',
            },
            deleteMandate: {
                url: '/api/my-billing-acc/mandate',
                method: 'DELETE',
            },
            createAlias: {
                url: '/api-user/my-account/create-alias',
                method: 'GET',
            },
            deleteAlias: {
                url: '/api/my-billing-acc/card-alias',
                method: 'DELETE',
            },
            selectPaymentMethod: {
                url: '/api/my-billing-acc/recurrent-cb',
                method: 'PUT',
            },
        }
    )
}

/** @ngInject */
function Hint($resource) {
    return $resource(
        'api-content/hints', { id_hint: '@id_hint' }, {
            getAll: {
                url: '/api-content/hints/search',
                method: 'GET',
                isArray: true,
            },
            saveComment: {
                url: '/api-content/hints/:id_hint/comments',
                method: 'POST',
            },
        }
    )
}

/** @ngInject */
function Tokens($resource) {
    return $resource(
        '', {}, {
            getToken: {
                url: '/tokens',
                method: 'POST',
            },
            getSignupToken: {
                url: '/anon/translate-subscription-token',
                method: 'POST',
            },
        }
    )
}

/** @ngInject */
function Community($resource) {
    return $resource(
        '/communaute/api/', {}, {
            getTrendingTopics: {
                url: '/communaute/api/recent',
            },
            getTopic: {
                url: '/communaute/api/topic/:id',
            },
            fetchUserInfo: {
                url: '/communaute/api/user/uid/:uid',
            },
            getUsers: {
                url: '/communaute/api/users',
            },
            getMostActiveUsers: {
                url: '/communaute/api/users/sort-posts',
            },
            getOnlineUsers: {
                url: '/communaute/api/users/online',
            },
            getChats: {
                url: '/communaute/api/chats',
            },
            getNotifications: {
                url: '/communaute/api/notifications',
            },
            getTrendingFaq: {
                url: '/communaute/api/category/8/faq',
            },
            getLastBlogPosts: {
                url: '/communaute/api/category/3/l-actu-plüm-énergie',
            },
        }
    )
}

/** @ngInject */
function BillingAddress($resource) {
    return $resource(
        'api-user/selfcare', {}, {
            showBillAddresses: {
                url: '/api-user/selfcare/lookup-addr',
                method: 'GET',
                isArray: true,
            },
        }
    )
}

/** @ngInject */
function Features($resource) {
    return $resource('/anon/features')
}

/** @ngInject */
function ProviderInfo($resource) {
    return $resource('/api/references/provider-info')
}

/** @ngInject */
function LandscapeQuestions($resource) {
    return $resource(
        '/api-user/landscape', {
            category: '@category',
            id_contract: '@id_contract',
            id_answer: '@id_answer',
            id_question: '@id_question',
        }, {
            getAll: {
                url: '/api-user/landscape?',
                method: 'GET',
                isArray: true,
            },
            getPopupQuestion: {
                url: '/api-user/landscape/popup/:id_question',
                method: 'GET',
            },
            search: {
                url: '/api-user/landscape/:id_contract/questions?category=:category',
                method: 'GET',
                isArray: true,
                category: '@cat',
            },
            saveAnswer: {
                url: '/api-user/landscape/:id_contract/answer',
                method: 'POST',
            },
            delAnswer: {
                url: '/api-user/landscape/:id_contract/answer/:id_answer',
                method: 'DELETE',
            },
            flush: {
                url: '/api-user/landscape/:id_contract/flush',
                method: 'DELETE',
            },
            flushAfter: {
                url: '/api-user/landscape/:id_contract/flush-after/:id_question',
                method: 'DELETE',
            },
        }
    )
}

/** @ngInject */
function DataAccessReferences($resource) {
    return $resource(
        'all', {}, {
            ref: {
                url: '/api/references/:id',
                method: 'GET',
            },
        }
    )
}

/** @ngInject */
function DataAccessVariables($resource) {
    return $resource(
        'all', {}, {
            get: {
                url: '/api/get/:variables',
                method: 'GET',
            },
        }
    )
}

/** @ngInject */
function CampaignLanding($resource) {
    return $resource(
        '/anon/campaigns', { id_campaign: '@id_campaign' }, {
            getCampaign: {
                url: '/anon/campaigns/:id_campaign',
                method: 'GET',
            },
            // type: 100 ==> visite: au loading de la page
            // type: 110 ==> subscribe: qd il rentre son email avec son email donc
            submitCampaignInformation: {
                url: '/anon/campaigns/:id_campaign',
                method: 'POST',
            },
        }
    )
}

/** @ngInject */
function RefGoals($resource) {
    return $resource(
        '/api/ref-goals', {}, {
            getGoals: {
                method: 'GET',
                isArray: true,
            },
        }
    )
}

/** @ngInject */
function Contact($resource) {
    return $resource(
        '/anon/contact', {}, {
            sendMessage: {
                method: 'POST',
            },
        }
    )
}

/** @ngInject */
function LogNavigation($resource) {
    return $resource(
        'log', {}, {
            log: {
                url: '/api-content/nav',
                method: 'POST',
            },
        }
    )
}

/** @ngInject */
function NavError($resource) {
    return $resource(
        '/api-content/nav-error', {}, {
            sendError: {
                method: 'POST',
            },
        }
    )
}

/** @ngInject */
function TariffResource($q, StaticTariff) {
    // static tariff while waiting for webservice with correct price
    const staticTariff$ = $q.resolve(StaticTariff)
    return {
        getTariff() {
            return { $promise: staticTariff$ }
        },
    }
}

/** @ngInject */
function SelfReport($resource) {
    return $resource(
        '/anon/self-report/:token', { token: '@token' }, {
            get: {
                method: 'GET',
            },
            post: {
                method: 'POST',
            },
        }
    )
}

/** @ngInject */
function AnonPayment($resource) {
    return $resource(
        '', {}, {
            getToken: {
                url: '/api-user/payment-token/:tokenId',
                method: 'GET',
            },
            getRedirect: {
                url: '/api-user/regularization/:tokenId',
                method: 'GET',
            },
            getOrderReference: {
                url: '/api-user/slimpay-order/:order_reference/status',
                method: 'GET',
            },
        }
    )
}

/** @ngInject */
function AnonTermination($resource) {
    return $resource(
        '', {}, {
            createTerminationToken: {
                url: '/api-user/my-contract/:id_contract/termination-token',
                method: 'POST',
            },
            getTerminationToken: {
                url: '/api-user/anon/confirm-termination/:tokenId',
                method: 'GET',
            },
            confirmTermination: {
                url: '/api-user/anon/confirm-termination/:tokenId',
                method: 'POST',
            },
            cancelTermination: {
                url: '/api-user/anon/confirm-termination/:tokenId',
                method: 'DELETE',
            },
        }
    )
}

/** @ngInject */
function SecurityDeposit($resource) {
    return $resource(
        '', {}, {
            getToken: {
                url: '/api-user/security-deposit/:tokenId',
                method: 'GET',
            },
            getRedirect: {
                url: '/api-user/security-deposit-redirect/:tokenId',
                method: 'GET',
            },
            refuseDeposit: {
                url: '/api-user/refuse-deposit/:tokenId',
                method: 'POST',
            },
        }
    )
}

/** @ngInject */
function BillingAcc($resource) {
    return $resource(
        '/api/my-billing-acc', {}, {
            getPaymentDay: {
                url: '/api/my-billing-acc/payment-day',
                method: 'GET',
            },
            putPaymentDay: {
                url: '/api/my-billing-acc/payment-day',
                method: 'PUT',
            },
        }
    )
}

/** @ngInject */
function Invoice($resource) {
    return $resource(
        '/invoices', { id_payment: '@id_payment', id_invoice: '@id_invoice' }, {
            sendRegulateSituation: {
                url: '/api-user/payment/:id_payment/retry',
                method: 'POST',
            },
            sendPayNextPayment: {
                url: '/api-user/payment/:id_payment/next-timetable',
                method: 'POST',
            },
            sendInvoiceByMail: {
                url: '/api-user/invoices/:id_invoice/email',
                method: 'GET',
            },
            creditCardRedirect: {
                url: '/api-user/payment/:id_payment/credit-card-redirect',
                method: 'GET',
            },
            getPayment: {
                url: '/api/my-payments/:payment_id',
                method: 'GET',
            },
            getPayments: {
                url: '/api/my-payments',
                method: 'GET',
                isArray: true,
            },
        }
    )
}



// WEBPACK FOOTER //
// ./src/models/resources.js